import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { i18n } from 'utils/i18n';
import { analyticsInteraction } from 'utils/analytics';
import { ANALYTICS, MODAL } from 'constants';
import Button from 'components/Button';
import PrePaymentTCRequestModalContent from 'components/PrePaymentTCRequestModalContent';

/**
 * LearnAboutPrepayAndPayLaterContent component showing payment options copy and Prepay terms drawer
 *
 * @param {object}    props - React Props
 * @param {object}    props.authenticated - indicates whether Alamo Insider user is signed in
 * @param {boolean}   props.guaranteedRes - indicates whether this is a guaranteed reservation vehicle
 * @return {JSX}      LearnAboutPrepayAndPayLaterContent component
 */
const LearnAboutPrepayAndPayLaterContent = ({ authenticated, guaranteedRes }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandDrawer = () => {
    setExpanded(!expanded);

    // Analytics - fire custom "drawer" event (push to interaction object)
    analyticsInteraction(
      ANALYTICS.DRAWER, // type
      ANALYTICS.PREPAY_POLICY, // key
      expanded ? ANALYTICS.CLOSE : ANALYTICS.OPEN // value
    );
  };

  return (
    <div
      className='pre-pay-terms-modal modal-themed__paragraph padding-top--condensed'
      id={`${MODAL.LEARN_ABOUT_PREPAY_AND_PAY_LATER}_desc`}
    >
      <div className='modal-themed__section'>
        <h3 className='modal-themed__section__header pre-pay-terms-modal__pre-pay-header'>
          {i18n('pre_pay_terms_modal_pre_pay_header')}
        </h3>

        {i18n(authenticated ? 'authenticated_pre_pay_terms_modal_copy' : 'pre_pay_terms_modal_copy')}
      </div>

      <div className='modal-themed__section'>
        <h3 className='modal-themed__section__header'>{i18n('vehicle_select_pay_later')}</h3>

        {i18n(authenticated ? 'authenticated_pay_later_terms_modal_copy' : 'pay_later_terms_modal_copy')}
      </div>

      {guaranteedRes && (
        <div className='modal-themed__section guaranteed-res-section'>
          {i18n('guaranteed_selection_payment_policy')}
        </div>
      )}

      <div className='modal-themed__drawer-container'>
        <Button
          button={false}
          type='button'
          aria-expanded={expanded}
          className={cn('modal-themed__drawer', { 'modal-themed__drawer--expanded': expanded })}
          onClick={handleExpandDrawer}
        >
          {i18n('pre_pay_policy_drawer')}
        </Button>
      </div>

      {expanded && <PrePaymentTCRequestModalContent className='modal-themed__section modal-themed__gbo-content' />}
    </div>
  );
};

LearnAboutPrepayAndPayLaterContent.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  guaranteedRes: PropTypes.bool,
};

export default LearnAboutPrepayAndPayLaterContent;
